export const INVITE_STUDENTS_LINK_ID = 'invite-students-link';
